// src/components/admin/AdminSidebar.tsx
import React from "react";
import { Link, useLocation } from "react-router-dom";

const menuItems = [
 { path: "/admin/dashboard", label: "ダッシュボード" },
  { path: "/admin/users", label: "ユーザー管理" },
  { path: "/admin/plans", label: "プラン管理" },
  { path: "/admin/messages", label: "メッセージ管理" },
   { path: "/admin/sales", label: "売上管理" },
  { path: "/admin/notices", label: "お知らせ管理" },
  { path: "/admin/reviews", label: "レビュー管理" },
  { path: "/admin/results", label: "実績管理" },
  { path: "/admin/points", label: "ポイント管理" },
  { path: "/admin/affiliate-list", label: "アフィリエイト管理" },
  { path: "/admin/affiliate-sales", label: "アフィリ売上管理" },
  { path: "/admin/affiliate-link", label: "アフィリリンク発行" },
  { path: "/admin/logout", label: "ログアウト" },
];

const AdminSidebar: React.FC = () => {
  const location = useLocation();
  return (
    <aside
      style={{
        width: 220,
        background: "#1976d2",
        color: "#fff",
        minHeight: "100vh",
        padding: "32px 0",
        boxShadow: "2px 0 10px rgba(0,0,0,0.06)",
      }}
    >
      <div style={{ textAlign: "center", fontWeight: "bold", fontSize: "1.25rem", marginBottom: 32 }}>
        管理メニュー
      </div>
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {menuItems.map((item) => (
          <li key={item.path}>
            <Link
              to={item.path}
              style={{
                display: "block",
                padding: "12px 26px",
                color: "#fff",
                background: location.pathname.startsWith(item.path) ? "#1565c0" : "none",
                textDecoration: "none",
                fontWeight: location.pathname.startsWith(item.path) ? "bold" : "normal",
              }}
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default AdminSidebar;
